import customFetchBase from "../../../principal/customFetchBase";
import { createApi } from "@reduxjs/toolkit/query/react";

export const actasApi = createApi({
  reducerPath: "actasApi",
  baseQuery: customFetchBase,
  tagTypes: ["Actas"],
  endpoints: () => ({}),
});
